export * from './BaseMessage';

//user's messages
export * from './BindClickMessage';
export * from './ChangeTextMessage';
export * from './ExecuteScriptMessage';
export * from './CustomRefMessage';
export * from './AddEventListenerMessage';
export * from './SetAttributeMessage';
export * from './GetElementValueMessage';
export * from './SetInnerHtml';

//system messages
export * from './InitMessage';
export * from './CreateRefComponentMessage';
export * from './EnvelopedMessage';
export * from './DetectMyopRefsMessage';
export * from './GetElementValueMessage';
export * from  './GetAttributeMessage';

export * from './componentMessages/ExecuteComponentMethod';
export * from './componentMessages/SetMutationObserverMessage';
export * from './CleanupMessage';
export * from './DisposeMessage';
export * from './componentMessages/SetResizeObserverMessage';